<app-spinner [(show)]="loading"></app-spinner>

<ng-container *ngIf="!loading">

  <main class="esf-main-content esf-main-content--has-sidebar -has-transition" style="width: 100vw" [class.-is-open]="isOpened">
    <div class="esf-container main-content--full-screen" [class.full-screen-opened]="isOpened">
      <h1 class="esf-heading esf-heading--page esf-action-heading">
        <span class="esf-action-heading__text" i18n="@@tixxSelect.heading.eventDashboard">
          Event Dashboard
        </span>
        <span class="esf-action-heading__actions">
          <span class="esf-action-heading__action">
            <button class="esf-button esf-button--outlined esf-button--icon esf-button--icon-small"
                    [edsTooltip]="tooltipTranslations.i18nOpenWebpage"
                    (click)="openLottery()">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-maximize"></use>
              </svg>
            </button>
          </span>

        </span>
      </h1>

      <div class="esf-info-tile-grid esf-info-tile-grid--3">
        <app-lottery-details-info
                                  class="esf-info-tile-grid__item"
                                  style="display: flex; flex-direction: column;"
                                  [editable]="false"
                                  [selectedLottery]="selectedLottery">
        </app-lottery-details-info>

        <app-primary-requests
                              class="esf-info-tile-grid__item"
                              style="display: flex; flex-direction: column; flex-grow: 1"
                              [selectedLottery]="selectedLottery"
                              [eventKpis]="eventKpis">
        </app-primary-requests>
      </div>

      <div class="esf-accordion esf-accordion--info-tiles">
        <app-event-categories-list
                                   [selectedLottery]="selectedLottery"
                                   [categories]="eventKpis?.priceCategories"
                                   [(isPanelOpened)]="listOfPanels.primaryCategories">
        </app-event-categories-list>
        <app-execution-iteration-list
                                      *ngIf="selectedLottery.executionId"
                                      [selectedLottery]="selectedLottery"
                                      [executionIterations]="executionIterations">
        </app-execution-iteration-list>
      </div>

    </div>
  </main>

</ng-container>
